/*
 * ============================================
 * LAUNCH MODE - Temporary script for pre-launch
 * 
 * Blocks navigation to "Coming Soon" products
 * and shows a subtle pulse animation instead.
 * 
 * Remove this file after launch to restore
 * normal product functionality.
 * ============================================
 */

document.addEventListener('DOMContentLoaded', function () {
    // Collect all product URLs that have "Coming Soon" badge and their cards
    var comingSoonProducts = [];
    var comingSoonCards = document.querySelectorAll('.card--product');

    comingSoonCards.forEach(function (card) {
        var badge = card.querySelector('.badge.custom-coming-soon');
        if (badge) {
            var link = card.querySelector('a[href*="/products/"]');
            if (link) {
                comingSoonProducts.push({
                    url: link.getAttribute('href'),
                    card: card
                });
            }
        }
    });

    // Helper function to trigger pulse animation
    function triggerPulse(element) {
        element.classList.remove('coming-soon-pulse');
        void element.offsetWidth;
        element.classList.add('coming-soon-pulse');
        setTimeout(function () {
            element.classList.remove('coming-soon-pulse');
        }, 600);
    }

    // Helper function to find card by product URL
    function findCardByUrl(url) {
        for (var i = 0; i < comingSoonProducts.length; i++) {
            if (url && url.includes(comingSoonProducts[i].url)) {
                return comingSoonProducts[i].card;
            }
        }
        return null;
    }

    // Listen for clicks on the document
    document.addEventListener('click', function (e) {
        var handled = false;

        // Check if clicked on a product card with Coming Soon badge
        var card = e.target.closest('.card--product');
        if (card) {
            var comingSoonBadge = card.querySelector('.badge.custom-coming-soon');
            if (comingSoonBadge) {
                e.preventDefault();
                e.stopPropagation();
                triggerPulse(card);
                handled = true;
            }
        }

        // Check if clicked on a hotspot (the circles on the polaroid image)
        if (!handled) {
            var hotspot = e.target.closest('.hotspot');
            if (hotspot) {
                var hotspotHref = hotspot.getAttribute('href');
                var correspondingCard = findCardByUrl(hotspotHref);

                if (correspondingCard) {
                    e.preventDefault();
                    e.stopPropagation();

                    // Pulse animation on hotspot
                    triggerPulse(hotspot);

                    // Also pulse the corresponding product card
                    triggerPulse(correspondingCard);
                }
            }
        }
    }, true);
});
